<mat-form-field
  class="munily-text-field munily-date-field"
  [appearance]="materialAppearance"
  [floatLabel]="floatLabel"
  [class.munily-text-field--size-default]="size === 'default'"
  [class.munily-text-field--size-small]="size === 'small'"
  [class.munily-text-field--success]="showSuccessOutline()"
  [class.mat-form-field-invalid]="showError()"
  [class.munily-date-field--disabled]="disabled || resolvedControl.disabled"
>
  <mat-label *ngIf="label">{{ label }}</mat-label>

  <mat-icon
    *ngIf="iconLeading"
    matPrefix
    class="munily-tf-icon material-symbols-rounded"
    aria-hidden="true"
  >
    {{ iconLeading }}
  </mat-icon>

  <input
    matInput
    type="text"
    class="munily-date-field__input"
    [value]="displayValue"
    [placeholder]="placeholder"
    readonly
    [attr.aria-label]="label || placeholder"
    (click)="onInputClick()"
    (keydown)="onInputKeydown($event)"
    (blur)="onBlur()"
  />

  <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
  <mat-error *ngIf="showError()">{{ resolvedErrorMessage }}</mat-error>
</mat-form-field>
